<template>
    <div class="show_detail_wrap fc">
        <div class="top_box fr">
            <img :src="showInfo.logo" alt class="bg" />
            <img :src="showInfo.logo" alt class="poster" />
            <h3>{{showInfo.name}}</h3>
        </div>
        <div class="address_info fc">
            <span class="price">
                <strong>111</strong>元起
            </span>
            <div class="row fr ac">
                <img src="../../../static/imgs/mall/date.png" alt class="time_icon" />
                <span class="txt">{{showInfo.startdate}} ~ {{showInfo.enddate}}</span>
            </div>
            <div class="row fr">
                <img src="../../../static/imgs/mall/location.png" alt class="time_icon" />
                <div class="fc">
                    <span class="txt">{{showInfo.venue}}</span>
                    <span class="address">{{showInfo.venuesaddress}}</span>
                </div>
            </div>
        </div>
        <div class="show_detail">
            <h2>演出介绍</h2>
            <div class="info_content" v-html="showInfo.description"></div>
        </div>
        <div class="footer fr ac">
            <div class="service fc ac jc">
                <img src="../../../static/imgs/mall/service.png" alt />
                <span>客服</span>
            </div>
            <button @click="purchase">立即购票</button>
        </div>
        <div v-show="showLayer" class="layer fc">
            <h3>选择场次</h3>
            <div class="list fc">
                <span class="item" v-for="(item, index) in dateList" :key="index" @click="switchDate(item.dpiid)">{{item.playTimeDesc}}</span>
            </div>
            <h3>选择票面</h3>
            <span>根据所选票面随机分配座位</span>
            <div class="list fc">
                <span class="item" v-for="(item, index) in qtyList" :key="index">{{item.facePrice}}票面</span>
            </div>
            <div class="quantity fc">
                <div class="fr ac jsb">
                    <span><strong>选择数量</strong>（库存4）</span>
                    <div class="fr ac">
                        <span>-</span>
                        <span>1</span>
                        <span>+</span>
                    </div>
                </div>
            </div>
            <div class="total frr">
                <button class="next">下一步</button>
                <span class="total_price">合计：<strong>200</strong>元</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            did: this.$route.query.did,
            dpiid: "",
            showInfo: {},
            dateList: [],  // 场次列表
            qtyList: [],  // 不同票面余票数量列表
            showLayer: false
        };
    },
    components: {},
    created() {
        this.getShowInfo();
    },
    methods: {
        getShowInfo() {
            this.$post({
                method: "drama.detailV4",
                did: this.did,
                htmlDesc: "Y"
            }).then(res => {
                if (res.success) {
                    this.showInfo = res.data.drama;
                }
            });
        },
        purchase(){
            this.showLayer = true;
            this.getDatelist();
        },
        getDatelist(){
            this.$post({
                method: "drama.playitem.datelist",
                did: this.did
            }).then(res => {
                if(res.success){
                    this.dateList = res.data.dateList
                    if(res.data.dateList.length){
                        this.dpiid = res.data.dateList[0].dpiid
                        this.getQtyList()
                    }
                }
            })
        },
        getQtyList(){
            this.$post({
                method: "drama.playitem.ticketqtylist",
                dpiid: this.dpiid
            }).then(res => {
                if(res.success){
                    this.qtyList = res.data.ticketQtyList
                }
            })
        },
        switchDate(dpiid){
            this.dpiid = dpiid
        }
    }
};
</script>
<style lang="scss">
.top_box {
    width: 100%;
    height: 380px;
    box-sizing: border-box;
    padding: 46px 30px;
    position: relative;
    overflow: hidden;
    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -10;
        filter: blur(40px);
        overflow: hidden;
        transform: scale(1.2);
        // object-fit: cover;
    }
    .poster {
        width: 214px;
        height: 274px;
        border-radius: 10px;
    }
    h3 {
        width: calc(100% - 214px);
        box-sizing: border-box;
        padding: 0 20px;
        font-size: 30px;
        line-height: 42px;
        color: #fff;
    }
}
.address_info {
    padding: 0 30px;
    background: #fff;
    border-radius: 20px 20px 0 0;
    margin-top: -120px;
    .price {
        margin-left: 240px;
        font-size: 24px;
        color: #ed726e;
        strong {
            font-size: 40px;
            height: 90px;
            line-height: 90px;
        }
    }
    .row {
        margin: 10px 0;
        .time_icon {
            width: 32px;
            height: 32px;
            margin-right: 18px;
        }
        .txt {
            font-size: 28px;
            line-height: 32px;
        }
        .address {
            font-size: 24px;
            color: #999;
            margin: 10px 0;
        }
    }
}
.show_detail {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    background: #fff;
    h2 {
        font-size: 28px;
        line-height: 100px;
        font-weight: bold;
    }
    .info_content {
        padding-bottom: 100px;
        p {
            font-size: 28px !important;
            max-height: 100%;
            line-height: 50px;
            color: #999;
            img {
                width: 100% !important;
            }
        }
    }
}
.footer {
    width: 100%;
    height: 98px;
    position: fixed;
    bottom: 0;
    .service {
        width: 196px;
        height: 98px;
        background: #fff;
        img {
            width: 40px;
            height: 34px;
            margin-bottom: 10px;
        }
    }
    button {
        width: calc(100% - 196px);
        height: 98px;
        line-height: 98px;
        color: #222;
        font-size: 34px;
        background: #ffcc00;
        text-align: center;
    }
}
.layer {
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 5;
    background: #fff;
    padding: 0 30px;
    box-sizing: border-box;
    h3 {
        font-size: 30px;
        font-weight: bold;
        line-height: 70px;
    }
    .list {
        width: 100%;
        height: 400px;
        overflow-y: scroll;
        .item {
            width: 500px;
            height: 62px;
            line-height: 62px;
            text-align: center;
            background: #dededf;
            border-radius: 31px;
            margin-top: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/show/showDetail.vue